var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// elements/components/x-snackbar.ts
import "@adornis/ass/style.js";
import { animate } from "@lit-labs/motion";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { property } from "lit/decorators/property.js";
import { concatMap, firstValueFrom, Subject, timer } from "rxjs";
import { ChemistryLitElement } from "../../chemistry-lit-element.js";
import "../../renderable.js";
import "./x-flex";
var XSnackbar = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.doDisconnect = false;
    this.visible = false;
  }
  render() {
    return html`
      <x-flex wrapper ${animate({ properties: ["translate", "opacity"], onComplete: () => this._completeHide() })}>
        ${this._renderContent()}
      </x-flex>
    `;
  }
  _renderContent() {
    if (typeof this.content === "function")
      this.content = this.content(this);
    return this.content ? typeof this.content === "string" ? html` <x-text> ${this.content} </x-text> ` : this.content : html` <x-text> no content set </x-text> `;
  }
  static async show(content, durationMS = 6e3, minDurationMS = 1e3) {
    this.ensureInit();
    const autoHide = typeof content !== "function";
    this.queueSource.next({ content, durationMS, minDurationMS, autoHide });
  }
  static ensureInit() {
    if (this.hasBeenInitialized)
      return;
    this.hasBeenInitialized = true;
    this.snackbarTag = document.createElement("x-snackbar");
    this.queueSource.pipe(
      concatMap(async (instruction) => {
        document.body.appendChild(this.snackbarTag);
        await this.snackbarTag.hide();
        requestAnimationFrame(() => {
          this.snackbarTag._showElement(instruction);
        });
        await firstValueFrom(timer(instruction.minDurationMS));
      })
    ).subscribe();
  }
  _showElement(instruction) {
    this.doDisconnect = false;
    document.body.appendChild(this);
    this.content = instruction.content;
    this.visible = true;
    if (instruction.autoHide) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.hide(), instruction.durationMS);
    }
  }
  hide() {
    if (this.visible === false)
      return;
    this.doDisconnect = true;
    clearTimeout(this.timeout);
    this.visible = false;
    return new Promise((r) => this._hideResolve = r);
  }
  _completeHide() {
    this._hideResolve?.();
    if (this.doDisconnect)
      document.body.removeChild(this);
  }
  styles() {
    return [
      {
        "[wrapper]": {
          position: "fixed",
          bottom: "0",
          left: "50%",
          padding: `${this.spacing.sm} ${this.spacing.sm}`,
          borderRadius: this.sizes.borderRadiusSecondary,
          background: this.colors.dark.opacity(0.8),
          color: this.colors.on.dark,
          opacity: this.visible ? "1" : "0",
          translate: this.visible ? `0 -${this.spacing.md}` : "0 0",
          transform: "translateX(-50%)",
          zIndex: "1004"
        }
      }
    ];
  }
};
XSnackbar.queueSource = new Subject();
XSnackbar.hasBeenInitialized = false;
__decorateClass([
  property()
], XSnackbar.prototype, "visible", 2);
XSnackbar = __decorateClass([
  customElement("x-snackbar")
], XSnackbar);
export {
  XSnackbar
};
